import { useStudentVerification } from '../composables/useStudentVerification';

export default defineNuxtRouteMiddleware(async (to) => {
  const { isStudentVerificationRequired, resolveUserStudentVerification } = useStudentVerification({ route: to });

  if (isStudentVerificationRequired.value) {
    await resolveUserStudentVerification();
  }
});
